import { Measurements, entityStore } from '~/utility/BinSentry-ui-utility';
import { BnAction } from '../../common/bn-action';

class BinUpdateBulkDensity extends BnAction {
  constructor() {
    super();
    this.actionname = 'update-bulk-density';
    // Success/Error messages must be handled externally.
    //   Flash is suppressed because this component invalidates its href on response
    //   and bn-action clears its flash onEntityUpdate. Meaning the flash is only shown for a few ms.
    //   The href for this action is not the binHref as per usual, as bulkDensity is handled by BinContents
    this.suppressFlash = true;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('response', this._onResponse);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('response', this._onResponse);
  }

  _onResponse() {
    entityStore.invalidateHref(this.href);
  }

  preRender(action) {
    const measurement = Measurements.get('bulkDensity');
    const field = action.fields[0];
    const precision = measurement.system === 'imperial' ? 1 : 0;
    if (!Object.keys(field).includes('originalValue')) {
      field.originalValue = field.value;
    }
    field.value = measurement.convert({ bulkDensity: field.originalValue }, precision);
    field.suffix = measurement.unit;
  }

  preSubmit(fields) {
    const measurement = Measurements.get('bulkDensity');
    fields.set('bulkDensity', measurement.reverse({ bulkDensity: fields.get('bulkDensity') }));
  }
}

window.customElements.define('bin-update-bulk-density', BinUpdateBulkDensity);
